import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

export const InvalidTokenChip = () => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      label={t(Resources.Pages.Content.BankAccounts.InvalidTokenChip)}
      variant="outlined"
      color="warning"
      size="small"
    />
  );
};
